export default "__VITE_ASSET__CsxoNldE__"